import { render, staticRenderFns } from "./addMonth.vue?vue&type=template&id=6b846c64"
import script from "./addMonth.vue?vue&type=script&lang=js"
export * from "./addMonth.vue?vue&type=script&lang=js"
import style0 from "./addMonth.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports